import { render, staticRenderFns } from "./Logincode.vue?vue&type=template&id=4841d5c4"
import script from "./Logincode.vue?vue&type=script&lang=js"
export * from "./Logincode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports